import {Injectable} from '@angular/core';
import {UgAgPsiTotal} from '../interfaces';
import {productValuesType, louvreArea, area} from '../interfaces';
import {CurrentSystemService} from './currentSystem.service';

@Injectable()
export class WindLoadService {
	currentSystem = '';
	pv: productValuesType;
	uw: { withIsolation: 0, withOutIsolation: 0 };
	area: area;

	constructor(private currentSystemService: CurrentSystemService) { }

	/**
	 * set current system
	 */
	setCurrentSystem() {
		this.pv = this.currentSystemService.getCurrentPvs();
		this.currentSystem = this.currentSystemService.getCurrentSystem();
	}

	/**
	 * calculate windload
	 * @param louvreWidth
	 * @param louvreHeight
	 * @param louvreArea
	 * @param glass
	 */
	setWindLoad(louvreWidth, louvreHeight, louvreArea, glass){

		switch (this.currentSystem) {
			case 'FLW28':
				return this.windLoadFLW28(louvreWidth, louvreHeight);
			case 'FLW24':
				return this.windLoadFLW24(louvreWidth, louvreHeight);
			case 'FLL':
				return this.windLoadFLL();
			case 'FLM':
				return this.windLoadFLM(louvreArea.louvreArea, glass);
			case 'FLW40':
			case 'FLW32':
				return this.windLoadFLW40AndFLW32(louvreWidth, louvreHeight);
			default:
				return 'no wind load calculated!'
		}
	}

	/**
	 * calculate wind load FLM
	 * @param louvreArea
	 * @param glass
	 */
	private windLoadFLM(louvreArea, glass){

		if (glass === 8 && louvreArea <= this.pv.windLoadCalculation['wl1100'][0].aMax && louvreArea > this.pv.windLoadCalculation['wl1250'][0].aMax){
			return 'WL 1100';
		}

		if (glass === 8 && louvreArea <= this.pv.windLoadCalculation['wl1250'][0].aMax){
			return 'WL 1250';
		}

		if (glass === 10 && louvreArea <= this.pv.windLoadCalculation['wl1750'][0].aMax && louvreArea > this.pv.windLoadCalculation['wl2000'][0].aMax) {
			return 'WL 1750';
		}

		if (glass === 10 && louvreArea <= this.pv.windLoadCalculation['wl2000'][0].aMax) {
			return 'WL 2000';
		}

		if (glass === 12 && louvreArea <= this.pv.windLoadCalculation['wl2250'][0].aMax && louvreArea > this.pv.windLoadCalculation['wl2900'][0].aMax){
			return 'WL 2250';
		}

		if (glass === 12 && louvreArea <= this.pv.windLoadCalculation['wl2900'][0].aMax) {
			return 'WL 2900';
		}

		return 'n.p.d'
	}

	/**
	 * calculate wind load FLW24
	 * @param louvreWidth
	 * @param louvreHeight
	 */
	private windLoadFLW24(louvreWidth, louvreHeight){
		let windLoad = 'n.p.d';

		if (louvreHeight <= this.pv.windLoadCalculation['wl2000'][0].hMax) {
			windLoad = 'WL 2000'
		}

		this.pv.windLoadCalculation['wl2250'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2250'
			}
		});

		this.pv.windLoadCalculation['wl2500'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2500'
			}
		});

		this.pv.windLoadCalculation['wl2750'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2750'
			}
		});

		this.pv.windLoadCalculation['wl3000'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 3000'
			}
		});

		return windLoad;
	}

	/**
	 * calculate wind load FLW28
	 * @param louvreWidth
	 * @param louvreHeight
	 */
	private windLoadFLW28(louvreWidth, louvreHeight){
		let windLoad = 'n.p.d';

		if (louvreHeight <= this.pv.windLoadCalculation['wl1500'][0].hMax) {
			windLoad = 'WL 1500'
		}

		this.pv.windLoadCalculation['wl2000'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2000'
			}
		});

		this.pv.windLoadCalculation['wl2250'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2250'
			}
		});

		this.pv.windLoadCalculation['wl2500'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2500'
			}
		});

		this.pv.windLoadCalculation['wl2750'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2750'
			}
		});

		this.pv.windLoadCalculation['wl3000'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 3000'
			}
		});

		return windLoad;
	}

	/**
	 * calculate wind load FLL
	 */
	private windLoadFLL(){

		// if(louvreArea <= this.pv.windLoadCalculation['wl1500'].aMax && louvreArea > this.pv.windLoadCalculation['wl3000'].aMax) {
		// 	return 'WL 1500' ;
		// }
		// if (louvreArea <= this.pv.windLoadCalculation['wl3000'].aMax) {
		// 	return 'WL 3000';
		// }

		// always return WL 3000
		return 'WL 3000'
	}

	/**
	 * calculate wind load FLW40 and FLW32
	 * @param louvreWidth
	 * @param louvreHeight
	 */
	private windLoadFLW40AndFLW32(louvreWidth, louvreHeight) {
		let windLoad = 'n.p.d';

		this.pv.windLoadCalculation['wl1500'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 1500'
			}
		});

		this.pv.windLoadCalculation['wl1750'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 1750'
			}
		});

		this.pv.windLoadCalculation['wl2000'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2000'
			}
		});

		this.pv.windLoadCalculation['wl2250'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2250'
			}
		});

		this.pv.windLoadCalculation['wl2500'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2500'
			}
		});

		this.pv.windLoadCalculation['wl2750'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 2750'
			}
		});

		this.pv.windLoadCalculation['wl3000'].forEach((dimensions) => {
			if (dimensions.wMax > louvreWidth && dimensions.hMax > louvreHeight) {
				windLoad = 'WL 3000'
			}
		});

		return windLoad;
	}
}
